module.exports = __webpack_public_path__ + "img/share-tab-active.2bb3560f.png";